import { hasResourceAccess } from '@Data/utils/policyManifest';

import { PolicyScope, SystemPermission } from '@/types/enums';

import type { PageResourceData, SdkIdentity, SdkPermissions, SdkResourceOperation } from './types';

const resourceOperationScopes: Record<SdkResourceOperation, number> = {
  list: Number(PolicyScope.Index),
  search: Number(PolicyScope.Index),
  get: Number(PolicyScope.Show),
  create: Number(PolicyScope.Store),
  createMany: Number(PolicyScope.StoreMany),
  update: Number(PolicyScope.Update),
  delete: Number(PolicyScope.Destroy),
  restore: Number(PolicyScope.Restore),
  count: Number(PolicyScope.Count),
  analytics: Number(PolicyScope.Aggregate),
  validate: Number(PolicyScope.Validate)
};

export function createSdkPermissions(identity: SdkIdentity): SdkPermissions {
  const permissionIds = identity?.$permission_ids ?? [];
  const permissionSlugs = identity?.$permission_slugs ?? [];
  const has = (permissionIdOrSlug: string) =>
    permissionIds.includes(permissionIdOrSlug) || permissionSlugs.includes(permissionIdOrSlug);

  return {
    has,
    hasAny: (permissionIdsOrSlugs) => permissionIdsOrSlugs.some(has),
    isSystemAdmin: () => has(SystemPermission.SystemAdministrator)
  };
}

export function canPerformResourceOperation(
  resource: Pick<PageResourceData, 'policy_scope'>,
  operation: SdkResourceOperation
): boolean {
  if (!Object.prototype.hasOwnProperty.call(resourceOperationScopes, operation)) {
    throw new Error(
      `Unknown resource operation '${operation}'. Available: ${Object.keys(resourceOperationScopes).join(', ')}`
    );
  }

  return hasResourceAccess(resource, resourceOperationScopes[operation]);
}
